import { Component } from '@angular/core';
import { Platform, AlertController, NavController, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as firebase        from 'firebase';
import { AuthService } from './service/auth.service';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { NavigationExtras, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { FcmService } from './service/fcm.service';
import { FCM } from '@ionic-native/fcm/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  email: string;
  password: string;
  phoneNumber : string;
  userInfo : any;
  title :string ;
  apk : any;
  
  public verifyBtnDisable   : boolean = true;
  public sendCodeBtnDisable : boolean = false;
  public isLoginWithPhone   : boolean = false;
  phoneNumberWithCode           : any;
  public isNotificationSetup : any = false;
    
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Connections',
      url: '/connection-page',
      icon: 'people'
    },
    {
      title: 'Request Pending',
      url: '/request-access',
      icon: 'git-pull-request-outline'
    },
    {
      title: 'Orders',
      url: '/order-section',
      icon: 'cart'
    }
  ];
  public appPages1 = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Orders',
      url: '/order-section',
      icon: 'cart'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public authService: AuthService,
    private alertCtrl      : AlertController,
    private navCtrl      : NavController,
    private androidPermissions: AndroidPermissions,
    public router : Router,
    public menu   : MenuController,
    private titleService     : Title,
    public fcmService : FcmService,
    private fcm             : FCM,
  ) {
    var self = this;
    this.initializeApp();
    this.userInfo = localStorage;

    // set browser title from environment page
    this.title = environment.ownerName;
    this.titleService.setTitle(this.title);
    this.apk = environment.APK;

    //FCM PUSH Notification do this only when platform is ios or android 
    if(this.apk) {
      if (!this.platform.is('ios') || this.platform.is('android')) {
        // call notification setup only if user id gets
        firebase.auth().onAuthStateChanged((user) => {
          if (user && !this.isNotificationSetup) {
            this.isNotificationSetup = true;
            // set token
            this.fcmService.setToken(user.uid);
            // this.callNotification();
            //var self = this;
            this.fcm.onNotification().subscribe(function(data) {
            	 this.redirect = true;
            	 if (data.wasTapped) {
            		 this.redirect = true;
            		// Notification was received on device tray and tapped by the user.
            		self.doNotificationRedirect(data.objectData);
            	  } 
            });
          }
        });
      }
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      
      // document.addEventListener("deviceready", onDeviceReady, false);
      

      function successCallback(result) {
        console.log(result); // true - enabled, false - disabled
      }

      function errorCallback(error) {
        console.log(error);
      }


      document.addEventListener("onTookScreenshot",function(){
      // Receive notification when screenshot is ready;
      });

      document.addEventListener("onGoingBackground",function(){
      // Receive notification when control center or app going in background.
      });
    });

    const successCallback = (data) => {
      console.log('data', data);
    }

    const errorCallback = (data) => {
      console.log('data', data);
    }

    // Enable
  
    // // Disable
    // function onDeviceReady() {
    //   window.plugins.preventscreenshot.disable(successCallback, errorCallback);
    // }
    // var self = this;
    // if(self.platform.is('android')) {
    //   //check read sms permission
    //   self.androidPermissions.checkPermission(self.androidPermissions.PERMISSION.READ_SMS)
    //   .then(
    //     result => {
    //       if(result.hasPermission) {
    //         // call a function to process picked image!
    //       } else {
    //         // ask for permission!
    //         self.androidPermissions.requestPermissions(self.androidPermissions.PERMISSION.READ_SMS)
    //         .then(
    //           result => {
    //         }, err => self.androidPermissions.requestPermissions(self.androidPermissions.PERMISSION.READ_SMS));
    //       }
    //   }, err => self.androidPermissions.requestPermissions(self.androidPermissions.PERMISSION.READ_SMS));
      
    //   //check receive sms permission
    //   self.androidPermissions.checkPermission(self.androidPermissions.PERMISSION.RECEIVE_SMS)
    //   .then(
    //     result => {
    //       if(result.hasPermission) {
    //         // call a function to process picked image!
    //       } else {
    //         // ask for permission!
    //         self.androidPermissions.requestPermissions(
    //           self.androidPermissions.PERMISSION.RECEIVE_SMS
    //         )
    //         .then(
    //           result => {
    //         }, err => self.androidPermissions.requestPermissions(
    //             self.androidPermissions.PERMISSION.RECEIVE_SMS
    //         ));
    //       }
    //   }, err => self.androidPermissions.requestPermissions(
    //       self.androidPermissions.PERMISSION.RECEIVE_SMS
    //   ));
    // }
  }

  // setDocTitle(title: string) {
  //   console.log('current title:::::' + this.titleService.getTitle());
  //   this.titleService.setTitle(this.title);
  // }
 
  showProfile() {
    this.router.navigateByUrl("/edit-profile");
    this.menu.close();
  }
  
  signup() {
    this.authService.signup(this.email, this.password);
    this.email = this.password = '';
  }

  login() {
    this.authService.login(this.email, this.password);
    this.email = this.password = '';    
  }

  logout() {
    this.authService.logout();
  }


  doNotificationRedirect(objectData1){
		var self = this;
		var objectData = JSON.parse(objectData1);
		if(objectData.fireFor == 'PLACE_ORDER' || objectData.fireFor == 'CANCEL_ORDER' || objectData.fireFor == 'ORDER_STATUS_UPDATE'){
			const object2 = {
        orderProductObject     : objectData,
        orderTabStatus         : 'sellerOrder'
	    }
      let navigationExtras: NavigationExtras = {state: {object: JSON.stringify(object2)}};
			self.router.navigateByUrl('/display-user-order-product-detail',navigationExtras)
		} else if(objectData.fireFor == 'SHARED_PRODUCT') {
      const object2 = {
        id        : objectData,
        userObj   : objectData ? objectData.userObj :"",
	    }
      let navigationExtras: NavigationExtras = {state: {object: JSON.stringify(object2)}};
			self.router.navigateByUrl('/product-list',navigationExtras)
    } else if(objectData.fireFor == 'SHARED_FOLDER') {
      const object2 = {
        id        : objectData,
        userObj   : objectData ? objectData.userObj :"",
        type : 'folder',
	    }
      let navigationExtras: NavigationExtras = {state: {object: JSON.stringify(object2)}};
			self.router.navigateByUrl('/product-list',navigationExtras)
    } else if(objectData.fireFor == 'SENT_REQUEST') {
      const object2 = {
        orderProductObject     : objectData,
	    }
      let navigationExtras: NavigationExtras = {state: {object: JSON.stringify(object2)}};
			self.router.navigateByUrl('/request-access',navigationExtras)
    } else if(objectData.fireFor == 'REQUEST_ACCEPTED') {
      const object2 = {
        orderProductObject     : objectData,
	    }
      let navigationExtras: NavigationExtras = {state: {object: JSON.stringify(object2)}};
			self.router.navigateByUrl('/connection-page',navigationExtras)
    }
  }
  
  async showModal(header, message, buttons) {
    var alertM = await this.alertCtrl.create({
      header : header,
      message: message,
      buttons: ['OK']
    });
    await alertM.present();
  }
}
